import BaseBehavior from '../../../framework/base/base';
import { openPopup } from '../../../shared/utilities/openPopup';

export default class ShareBar extends BaseBehavior {
	constructor(element) {
		super(element);

		const locationTitle = this.element.getAttribute('data-location-title');
		const locationUrl = this.element.getAttribute('data-location-url');

		if (locationTitle && locationUrl) {
			this.url = encodeURIComponent(locationUrl);
			this.title = encodeURIComponent(locationTitle);
			this.body = encodeURIComponent(`${locationTitle}\n${locationUrl}\n\n`);
		} else {
			this.url = encodeURIComponent(window.location.href);
			this.title = encodeURIComponent(document.title);
			this.body = encodeURIComponent(`${document.title}\n${window.location.href}\n\n`);
		}

		this.shareURLs = {
			buffer: `https://buffer.com/add?source=button&url=${this.url}&text=${this.title}`,
			email: `mailto:?subject=${this.title}&body=${this.body}`,
			facebook: `https://www.facebook.com/share.php?u=${this.url}`,
			'google-plus': `https://plus.google.com/share?url=${this.url}`,
			linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${this.url}&title=${this.title}`,
			pinterest: `https://pinterest.com/pin/create/button/?url=${this.url}&description=${this.title}`,
			tumblr: `https://www.tumblr.com/share/link?url=${this.url}&name=${this.title}&description=`,
			twitter: `https://twitter.com/intent/tweet?url=${this.url}&text=${this.title}&via=saxobank`,
			vk: `https://vkontakte.ru/share.php?url=${this.url}`,
			weibo: `http://service.weibo.com/share/share.php?url=${this.url}&title=${this.title}`,
			line: `https://social-plugins.line.me/lineit/share?url=${this.url}`
		};

		this.addEventListeners();
	}

	addEventListeners() {
		this.addEventListener(this.element, 'click', e => {
			let network;
			let popUpUrl;

			if (this.element.getAttribute('data-url')) {
				popUpUrl = this.element.getAttribute('data-url');
			}

			if (this.element.getAttribute('data-network')) {
				network = this.element.getAttribute('data-network');
				popUpUrl = this.shareURLs[network];
			}

			if (popUpUrl) {
				this.element.setAttribute('href', popUpUrl);

				if (network !== 'email') {
					e.preventDefault();
					openPopup(popUpUrl);
				}
			} else {
				throw new Error('Share-Bar: data-url or data-network attribute missing.');
			}
		});
	}

	removeEventListeners() {
		this.removeEventListener(this.element, 'click');
	}

	cleanup() {
		this.removeEventListeners();
	}
}
